var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1478.5px",
    height: "75.444px",
    viewBox: "0 1381.558 1478.5 75.444",
    enableBackground: "new 0 1381.558 1478.5 75.444",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2147.567,
    y: -343.934,
    fill: "#700CBF",
    width: 1478.5,
    height: 1338
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2080.4153,
    y1: -1651.3652,
    x2: 2963.6123,
    y2: -243.2631,
    gradientTransform: "matrix(1 0 0 1 -16.7197 664.1094)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    style: {
      stopColor: "#FF9339"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2147.567,
    y: -343.934,
    fill: "url(#SVGID_1_)",
    width: 1478.5,
    height: 1338
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#700CBF",
    d: "M1478.5,1250H0c0,157.15,0,157.15,0,157.15s187.916,85.188,467.767,32.528 c279.852-52.67,244.672-71.18,436.515-32.528c191.846,38.64,242.334,89.58,574.219,0V1250L1478.5,1250z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.e05f78ae5cd097cb62f3ffaaebab3937.svg";
export { ForwardRef as ReactComponent };